// src/models/Office.js
export default class Office {
  constructor({
    name,
    departmentId,
    officer,
    roles = [],
    workflowAddress = '',
  }) {
    this.name = name;
    this.departmentId = departmentId;
    this.officer = officer; // Could be a user ID or object reference
    this.roles = roles; // Array of roles associated with this office
    this.workflowAddress = workflowAddress; // Could be an address string or object
    this.createdAt = new Date(); // Timestamp when the office is created
  }

  // Method to convert the Office instance to a plain object for Firebase
  toFirestore() {
    return {
      name: this.name,
      departmentId: this.departmentId,
      officer: this.officer,
      roles: this.roles,
      workflowAddress: this.workflowAddress,
      createdAt: this.createdAt,
    };
  }
}
